export function calcSimilarity(myTop10: string[], myBottom5: string[], otherTop10: string[], otherBottom5: string[]): number {
  const top10Common = myTop10.filter(t => otherTop10.includes(t)).length;
  const bottom5Common = myBottom5.filter(t => otherBottom5.includes(t)).length;
  const crossPenalty = myTop10.filter(t => otherBottom5.includes(t)).length
    + otherTop10.filter(t => myBottom5.includes(t)).length;

  const raw = ((top10Common + bottom5Common - crossPenalty) / 15) * 100;
  return Math.round(raw);
}

export function getTop10(talents: string[]): string[] {
  return talents.slice(0, 10);
}

export function getBottom5(talents: string[]): string[] {
  return talents.slice(-5);
}
